module.exports = __webpack_public_path__ + "static/media/front.e0a1d399.jpg";